import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import Lottie from 'lottie-react';
import parseJson from '../helpers/parseJSON';
import { HeaderStyles } from './Header.styles';
import StorageService from '../../services/StorageService';
import sparkle from '../../assets/lottie/sparkle.json';

const Storage = new StorageService();

export default function Header({ setShowGreeniaAI, showGreeniaAI, setShowSidebar }) {
  const user = parseJson(localStorage.getItem('user'));

  const handleClick = () => {
    // localStorage.clear();

    Storage.removeBackOfficeToken();
    Storage.removeToken();
    Storage.removeUser();
    Storage.removeRefreshToken();
    Storage.removeSelectedProfession();
    Storage.removeVehicleQuoteAnswers();
    Storage.removeMotoQuoteAnswers();
    Storage.removeVehicleOwnerData();
    Storage.removeVehicleDriverData();
    Storage.removeBersani();
    Storage.removeTranscription();
    Storage.removeTravelData();

    window.location.href = '/';
  };

  return (
    <HeaderStyles>
      <nav className="page-nav">
        <div className="d-flex justify-content-between align-items-center">
          <button type="button" className="menu btn-lg d-lg-none" onClick={() => setShowSidebar(true)} aria-label="Apri menu">
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="search-box d-lg-flex d-none align-items-center">
            <button className="btn btn-dark gap-2 d-flex align-items-center justify-content-center" onClick={() => setShowGreeniaAI(!showGreeniaAI)}>
              <Lottie
                animationData={sparkle}
                loop
              />
              <p className="m-0 fw-semibold">Greenia AI</p>
            </button>
          </div>

          <div className="d-flex align-items-center justify-content-end">
            <div className="user-info">
              <span className="email">{user.email}</span>
              <br />
              <h6 className="fw-medium m-0">
                {user.name}
                {' '}
                {' '}
                {' '}
                {user.surname}
              </h6>
            </div>
            <button type="button" className="logout" onClick={handleClick} aria-label="Esci" title="Esci">
              <FontAwesomeIcon icon={faArrowRightFromBracket} />
            </button>
          </div>
        </div>
      </nav>
    </HeaderStyles>
  );
}
